import React from "react"
import ReactDOM from "react-dom"
import registerServiceWorker from "registerServiceWorker"

import { Provider } from "react-redux"
import configureStore from "redux/configureStore"
import rootSaga from "redux/rootSaga"

import App from "./scenes/App/App"
import "./reset.css"

const store = configureStore()
store.runSaga(rootSaga)

const element = document.getElementById("root")

let render = () => {
  const App = require("./scenes/App/App").default

  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    element
  )
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  element
)

if (module.hot) {
  const renderApp = render

  render = () => {
    try {
      renderApp()
    } catch (error) {
      console.error(error)
    }
  }

  module.hot.accept("./scenes/App/App", () => {
    setTimeout(render)
  })
}

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js